import { render } from "./BaseBorderAlert.vue?vue&type=template&id=fa52e49c"
import script from "./BaseBorderAlert.vue?vue&type=script&lang=js"
export * from "./BaseBorderAlert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__